import React from "react";

const TheDifferentItMade = () => {
  return (
    <div className="column-sections pb-20 pt-4 accross-market">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="column-content pb-40 text-left">
            <div className="singel_about_left_inner d-flex text-left">
                <div className="about_icon mr-3">
                </div>
                <div className="singel-about-content">
                  <p><b>Results Across Markets</b></p>
                 <p> ● India and Japan drove the highest lead volumes, with Electronics leading at 41% and 44% respectively. Korea leaned heavily into Semiconductors (43%), while ASEAN showed balanced demand. Electronics (32%) and Semiconductors (22%) led the mix.

 <br/> ● ANZ, though smaller in volume, showed focused traction in Energy & Utilities (21%) and A&D (17%), signaling deeper vertical interest.
 <br/> ● CP&R, F&B, and Flexible Manufacturing added breadth across all regions, showing the campaign’s reach across varied industries.
<br/> ● ProPlus Data didn’t just gather leads; we tracked where demand was moving. High-intent signals surfaced faster, targeting sharpened, and conversions followed.

                  </p>
                </div>
              </div>
            </div>
          
          </div>
            <div className="singel_about_left_inner d-flex text-left">
                <div className="about_icon mr-3">
                </div>
                <div className="singel-about-content">
                 
                  <p><b>Here’s what that translated to on the ground:</b><br/>
                  ● More meaningful leads, fewer wasted ones.Quality went up, especially in previously underperforming sectors.
 <br/> ● Sales teams became more engaged because leads came with context, buyer type, signal source, and timing.
 <br/> ● Regional heads had clarity. Instead of chasing campaign volume, they could prioritize what was working and why.
 <br/> ● Marketing stopped being questioned. Attribution became cleaner, and spend could finally be tied to strategic outcomes, not vanity metrics.
                  </p>
                </div>

               
              </div>

              <div className="singel_about_left_inner d-flex text-left">
                <div className="about_icon mr-3">
                </div>
                <div className="singel-about-content">
                  <p><b>Most importantly, the client could now make decisions with confidence:</b><br/>
                  ● Where to invest.
 <br/> ● Where to expand.
 <br/> ● Where to pull back.
                  </p>
                </div>
              </div>

              
        </div>
      </div>
    </div>
  );
};

export default TheDifferentItMade;
